import React from 'react';
import classnames from 'classnames';
import 'src/components/Pagination/Pagination.scss';
import { Link } from 'react-router-dom';

type Props = {
    totalPages: number;
    currentPage: number;
    createUrl(any);
    refine?(val: number);
};

export function NextLink(props: Props) {
    const { totalPages, currentPage, createUrl, refine } = props;
    return (
        <li
            className={classnames({
                ['ais-Pagination-item']: true,
                ['ais-Pagination-item--nextPage']: true,
                ['ais-Pagination-item--disabled']: currentPage === totalPages,
            })}
        >
            {currentPage === totalPages && <span className="ais-Pagination-link">Next</span>}
            {currentPage !== totalPages && (
                <Link
                    className="ais-Pagination-link"
                    to={createUrl(currentPage + 1)}
                    onClick={(event) => {
                        if (!refine) return;
                        event.preventDefault();
                        refine(currentPage + 1);
                    }}
                >
                    Next
                </Link>
            )}
        </li>
    );
}
